import { HCP_TYPE } from "util";
import { CognipharmaHCPLookup } from "./cognipharma-platform";
import { disableAnalytics } from "./analytics";

export const authenticateHCP = async (hcpType, name, licenseNumber) => {
	localStorage.removeItem("cogni-user-id");
	localStorage.removeItem("login-token");

	try {
		if (
			name?.toLowerCase() === "cognipharma" ||
			name?.toLowerCase() === "sps"
		) {
			if (licenseNumber === "23224") {
				localStorage.setItem("cogni-user-id", name.toLowerCase());
				localStorage.setItem(
					"login-token",
					hcpType + "|" + licenseNumber + "|" + name
				);
				localStorage.setItem("hcp-specialty", "Administrador");
				localStorage.setItem("hcp-all-specialties", "Administrador");

				if (name?.toLowerCase() === "cognipharma") {
					disableAnalytics();
				}

				return {
					isValid: true,
					datasource: "Administradores",
					validationMessage: "Acesso garantido",
				};
			} else {
				return {
					isValid: false,
					datasource: "Administradores",
					validationMessage: "Password Inválida",
				};
			}
		}

		// localStorage.setItem("cogni-user-id", name.toLowerCase());
		// localStorage.setItem("login-token", hcpType + "|" + licenseNumber + "|" + name);
		// return { isValid: true, datasource: "TESTE", validationMessage: "TESTE" };

		const results = await CognipharmaHCPLookup(hcpType, name, licenseNumber);

		console.log("HCP Authentication results", results);

		if (results?.isValid) {
			localStorage.setItem("cogni-user-id", name.toLowerCase());
			localStorage.setItem(
				"login-token",
				hcpType + "|" + licenseNumber + "|" + name
			);
			const fallback = fallbackSpecialty(hcpType);
			localStorage.setItem(
				"hcp-specialty",
				results.hcp_specialty || fallback
			);
			localStorage.setItem(
				"hcp-all-specialties",
				results.hcp_specialties || fallback
			);
			return {
				isValid: true,
				datasource: results.datasource,
				validationMessage: results.validationMessage,
			};
		} else {
			return {
				isValid: false,
				datasource: results?.datasource ?? "Sem datasource",
				validationMessage:
					results?.validationMessage ?? results?.error?.message,
			};
		}
	} catch (er) {
		console.log("Erro na autenticação", er);
		return {
			isValid: false,
			datasource: "-",
			validationMessage:
				"Erro Interno. Por favor contacte o suporte em support+sps@cognipharma.com",
		};
	}
};

export const logoutHCP = () => {
	localStorage.removeItem("cogni-user-id");
	localStorage.removeItem("login-token");
	localStorage.removeItem("hcp-specialty");
	localStorage.removeItem("hcp-all-specialties");
};
export const hcpIsLoggedIn = () => {
	return localStorage.getItem("login-token")?.length > 0;
};
export const hcpGetAuthInfo = () => {
	let data = localStorage.getItem("login-token");
	if (!data) return null;
	data = data.split("|");
	if (data.length !== 3) return null;
	return {
		hcpType: data[0],
		job: JobFromHCPType(data[0]),
		name: data[2],
		licenseNumber: data[1],
	};
};

export const hcpGetSpecialty = () => {
	return localStorage.getItem("hcp-specialty");
};

export const hcpGetAllSpecialties = () => {
	return localStorage.getItem("hcp-all-specialties");
};

function fallbackSpecialty(hcpType) {
	if (hcpType === HCP_TYPE.Nurse) return "Enfermeiro";
	if (hcpType === HCP_TYPE.Pharmacist) return "Farmacêutico";
	return "N/A";
}

function JobFromHCPType(hcpType) {
	switch (hcpType) {
		case HCP_TYPE.Doctor:
			return "Médico/a";
		case HCP_TYPE.Pharmacist:
			return "Farmacêutico/a";
		case HCP_TYPE.Nurse:
			return "Enfermeiro/a";
		default:
			return "Outra";
	}
}
